import Vue from 'vue';
import logger from "./logger.js";

Vue.config.errorHandler = async (err, vm, info) => {
    let trace = info ? info.toString() : 'N/A';
    await logger.error(`[Vue.Error] ${err.toString()}`, trace);
};

Vue.config.warnHandler = async (err, vm, info) => {
    let trace = info ? info.toString() : 'N/A';
    await logger.error(`[Vue.Warn] ${err.toString()}`, trace);
};

window.onerror = async (message, source, lineno, colno, error) => {
    await logger.error(`[Window.Error] ${message}`, source.toString());
};
